/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SteamNewsItem } from './SteamNewsItem';
import {
    SteamNewsItemFromJSON,
    SteamNewsItemFromJSONTyped,
    SteamNewsItemToJSON,
    SteamNewsItemToJSONTyped,
} from './SteamNewsItem';

/**
 * 
 * @export
 * @interface DropGameNewsResponse
 */
export interface DropGameNewsResponse {
    /**
     * Which app the feed came from. Absent when the Drop has no Steam identity.
     * @type {number}
     * @memberof DropGameNewsResponse
     */
    steamAppId?: number;
    /**
     * 
     * @type {Array<SteamNewsItem>}
     * @memberof DropGameNewsResponse
     */
    items: Array<SteamNewsItem>;
    /**
     * 
     * @type {number}
     * @memberof DropGameNewsResponse
     */
    computedAt: number;
}

/**
 * Check if a given object implements the DropGameNewsResponse interface.
 */
export function instanceOfDropGameNewsResponse(value: object): value is DropGameNewsResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('computedAt' in value) || value['computedAt'] === undefined) return false;
    return true;
}

export function DropGameNewsResponseFromJSON(json: any): DropGameNewsResponse {
    return DropGameNewsResponseFromJSONTyped(json, false);
}

export function DropGameNewsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropGameNewsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'steamAppId': json['steamAppId'] == null ? undefined : json['steamAppId'],
        'items': ((json['items'] as Array<any>).map(SteamNewsItemFromJSON)),
        'computedAt': json['computedAt'],
    };
}

export function DropGameNewsResponseToJSON(json: any): DropGameNewsResponse {
    return DropGameNewsResponseToJSONTyped(json, false);
}

export function DropGameNewsResponseToJSONTyped(value?: DropGameNewsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'steamAppId': value['steamAppId'],
        'items': ((value['items'] as Array<any>).map(SteamNewsItemToJSON)),
        'computedAt': value['computedAt'],
    };
}

